import { useEffect, useState, useCallback } from "react";
import Hero from "./Hero/Hero";
import HR from "./HR/HR";
import Jobs from "./Jobs/Jobs";
import JobApplicationForm from "./JobApplicationForm/JobApplicationForm";

// fetching data
import useFetch from "Hooks/useFetch";
import LoadingScreen from "Components/RequestHandler/LoadingScreen";

import IsError from "Components/RequestHandler/IsError";
const Carrer = () => {
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { fetchData, error } = useFetch();
  const [jobs, setJobs] = useState();

  const getData = useCallback(async () => {
    setIsLoading(true);
    setIsError(false);

    try {
      const data = await fetchData(`career`);
      setData(data);
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  }, [fetchData]);

  const getJobs = useCallback(async () => {
    setIsLoading(true);
    setIsError(false);

    try {
      const jobs = await fetchData("job-form-data");
      setJobs(jobs);
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  }, [fetchData]);

  useEffect(() => {
    getData();
    getJobs();
  }, []);

  if (isLoading) return <LoadingScreen />;
  if (error || isError) return <IsError />;
  if (data) {
    return (
      <main>
        <Hero data={data?.hero} />
        <HR data={data?.hr_values} />
        <Jobs data={data?.current_jobs} jobsData={jobs} />
        {/* {data?.current_jobs?.length !== 0 && <Jobs data={data?.current_jobs} />} */}
      </main>
    );
  }
};

export default Carrer;
